"use client";

import LinkIcon from "@heroicons/react/24/outline/LinkIcon";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { usePathname } from "next/navigation";

interface Props {
  description: string;
  headings: any[];
}

export default function BlogLinks(props: Props) {
  const pathname = usePathname();
  const [activeHeading, setActiveHeading] = useState<string | null>(null);

  const scroll = (hash?: string)=>{
    // Get the element
    const element = document.getElementById(hash);
    if (!hash || !element) return;

    // Get the position of the element
    const elementPosition = element.getBoundingClientRect().top + window.scrollY - 140;

    // Scroll to that position
    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    });
  }

  useEffect(() => {
    const handleHashChange = () => {
      if (typeof window !== "undefined") {
        const hash = window.location.hash.replace("#", "");
        setActiveHeading(hash);
        scroll(hash)
      }
    };

    handleHashChange(); // check initially
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [pathname]);

  if (!Array.isArray(props.headings) || !props.headings.length)
    return <span className="text-gray-400">Başlıklar Bulunamadı</span>;

  return (
    <div className="flex flex-col gap-2">
      {props.headings.map((title) => {
        return (
          <Link
            key={title.index}
            className={cn(
              `whitespace-normal flex gap-2 items-center duration-300`,
              activeHeading === title.id ? "text-rose-500" : "text-gray-400",
            )}
            href={`#${title.id}`}
            onClick={() => {
              setActiveHeading(title.id)
              scroll(title.id)
            }}
            scroll={false}
          >
            <LinkIcon
              className={cn(
                `size-4 text-xl duration-300`,
                activeHeading === title.id ? "text-rose-500" : "text-gray-400",
              )}
            />
            <span className="flex-1 text-ellipsis overflow-hidden text-left line-clamp-2">
              {title?.textContent}
            </span>
          </Link>
        );
      })}
    </div>
  );
}
